import React, {useContext} from 'react';
import {Box} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import AppContext from '@crema/utility/AppContext';
import {ThemeMode} from '../../shared/crema/constants/AppEnums';
import Hidden from '@material-ui/core/Hidden';
import AppContextPropsType from '../../types/crema/AppContextPropsType';

const AppLogo = () => {
  const {themeMode} = useContext<AppContextPropsType>(AppContext);
  const useStyles = makeStyles(() => ({
    logoRoot: {
      display: 'flex',
      flexDirection: 'row',
      cursor: 'pointer',
      alignItems: 'center',
    },
    logo: {
      height: 36,
      marginRight: 10,
    },
  }));
  const classes = useStyles();
  return (
    <Box className={classes.logoRoot}>
      <Hidden smUp>
        <img
          className={classes.logo}
          src={
            themeMode === ThemeMode.DARK
              ? '/assets/images/logo/tclick_logo_icon_white.svg'
              : '/assets/images/logo/tclick_logo_icon.svg'
          }
          alt='templeclick-logo'
        />
      </Hidden>
      <Hidden xsDown>
        <img
          className={classes.logo}
          src={
            themeMode === ThemeMode.DARK
              ? '/assets/images/logo/tclick_logo_white.svg'
              : '/assets/images/logo/tclick_logo.svg'
          }
          alt='templeclick-logo'
        />
      </Hidden>
    </Box>
  );
};

export default AppLogo;
